export default {"src":"/login-app/[GIT_HASH]/_next/static/media/control_flow.b021e411.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};